<template>
  <div
    class="pa-3"
    style="height: 340px">
    <v-text-field
      filled
      style="height: 66px"
      label="Name"
      v-model="data.name"
      v-on:keyup.enter="$emit('create')"></v-text-field>
    <v-text-field
      filled
      style="height: 66px"
      label="URL"
      v-model="data.url"
      v-on:keyup.enter="$emit('create')"></v-text-field>
    <v-checkbox
      v-model="data.auth"
      label="Authentication Required"
      hide-details></v-checkbox>
    <v-text-field
      v-if="data.auth"
      filled
      style="height: 66px"
      label="Username"
      v-model="data.username"
      v-on:keyup.enter="$emit('create')"></v-text-field>
    <v-text-field
      v-if="data.auth"
      filled
      style="height: 66px"
      label="Password"
      v-model="data.password"
      v-on:keyup.enter="$emit('create')"></v-text-field>
  </div>
</template>

<script setup>
import { ref, reactive, watch } from 'vue';

const props = defineProps({
  userEditObj: {
    type: Object,
    default: () => ({}),
  },
});

const emit = defineEmits(['update:data', 'create']);

const data = reactive({
  name: '',
  url: '',
  username: '',
  password: '',
  auth: false,
});

// Watch for changes in the data and emit them
watch(
  data,
  () => {
    emit('update:data', JSON.parse(JSON.stringify(data)));
  },
  { deep: true, immediate: true }
);
</script>
